export class Player{
    private playerId:string;
    private points:number;
    private hits:number;
    private isKilled:boolean;

    constructor(playerId:string,hits:number,points:number,isKilled:boolean){
        this.playerId=playerId;
        this.hits=hits;
        this.isKilled=isKilled;
        this.points=points;
    }

    public getPoints():number{
        return this.points;
    }

    public getHits(): number {
        return this.hits;
    }

    public getIsKilled():boolean{
        return this.isKilled;
    }

    public setIsKilled(value : boolean):void{
        this.isKilled=value;
    }

    public getPlayerId():string{
        return this.playerId;
    }
}